import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/storage';
import format from 'date-fns/format'
//import utcToZonedTime from  'date-fns/date-fns-tz'
import _ from 'lodash'
// import startOfWeek from 'date-fns/start_of_week';
// import endOfWeek from 'date-fns/end_of_week';
// import startOfMonth from 'date-fns/start_of_month';
import endOfMonth from 'date-fns/end_of_month';
// import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import moment from 'moment';
import { getCategory, getTeamByCompany } from './core/cacheService';
import { PROGRAM_ONLY_KEY, EVERYONE_KEY, normalizeHuddleValue } from './huddle-helpers';
import { toWriteOptions } from './checklist-item-helpers';
import { markdownFields } from '../components/markdown';

const PROGRAM_ONLY_LABEL = 'Program only';
const PROGRAM_ONLY_ENTRY = {
  key: PROGRAM_ONLY_KEY,
  value: PROGRAM_ONLY_LABEL,
  programOnly: true,
  selected: true,
  show: true,
};

// "Program only" wins over Everyone wins over specific team/house picks —
// mirrors how Everyone has silently overridden specific selections in the
// existing codebase. Returns the document fields { delete, huddles }
// derived from the cascader's selected values.
function buildHuddleSave(huddles: any[], huddleTag: any): { filter: boolean; huddle: any[] } {
  const isProgramOnly = _.some(huddles, (v: any) => normalizeHuddleValue(v) === PROGRAM_ONLY_KEY);
  if (isProgramOnly) {
    return { filter: false, huddle: [{ ...PROGRAM_ONLY_ENTRY }] };
  }
  const isEveryone = _.some(huddles, (v: any) => normalizeHuddleValue(v) === EVERYONE_KEY);
  if (isEveryone) {
    return { filter: true, huddle: [] };
  }
  const huddle: any[] = [];
  (huddles || []).forEach((v: any) => {
    const key = normalizeHuddleValue(v);
    if (!key || key === EVERYONE_KEY || key === PROGRAM_ONLY_KEY) return;
    const tag = huddleTag[key];
    if (!tag) return;
    if (tag.type === 'houses') {
      huddle.push({ key: tag.value, value: tag.label, selected: true, show: true, house: true });
    } else {
      huddle.push({ key: tag.value, value: tag.label, selected: true, show: true, team: true });
    }
  });
  return { filter: false, huddle };
}

export default {
  namespaced: true,
  state: {
    townhall_all: [], // chart
    townhall_graphmonth:[],
    townhall_graphmonth16:[],
    townhall_total:0,
    townhall_total16:0,
    townHalls: [], // table
    townHallShowing: [],
    inputSearchTownhall: "",
    townHallTypingStatus: null,
    townHallSortField: "",
    townHallSortOrder: "",
    townhallSortBy: "class_name",
    townHallResults: 0,
    townHallPage: 1,
    size_page: 10,
    loadingTownHallTable: true,
    adviser:false,
    creator:[],
    huddleTagData:[],
    huddleTag:{},
    comment:[],
    commentId:'',
    userAll:{},
    member:[],
    organization1level:{},
    membersPoll:[],
    townhallTags: { tags: {} },
    scheduledTownhall: [],
    draftTownhall: [],
  },
  mutations: {
    SET_TOWNHALL_TAGS(state: any, doc: any) {
      state.townhallTags = doc || { tags: {} };
    },
    setTownhall(state: any, result: any) {
      state.townHalls = result
    },
    setTownhallAll(state: any, result: number) {
      state.townhall_all = result
    },
    setTownhallGraphMonth(state:any, result:any){
        state.townhall_graphmonth = result
    },
    setTownhallGraphMonth16(state:any, result:any){
        state.townhall_graphmonth16 = result
    },
    setAllTownhall(state:any, result:number){
        state.townhall_total = result
    },
    setAllTownhall16(state:any, result:number){
        state.townhall_total16 = result
    },
    setGraphMonth(state: any, result: any) {
      state.townhall_graphmonth = result
    },
    setInputSearchTownhall(state: any, value: any) {
      state.inputSearchTownhall = value
    },
    setTownhallSortBy(state: any, result: string) {
      state.townhallSortBy = result
    },
    setTownHallPage(state: any, result: any) {
      state.townHallPage = result
    },
    setTownHallResults(state: any, result: any) {
      state.townHallResults = result
    },
    setTownHallShowing(state: any, result: any) {
      state.townHallShowing = result
    },
    setTownHallSortField(state: any, result: any) {
      state.townHallSortField = result
    },
    settownHallSortOrder(state: any, result: any) {
      state.townHallSortOrder = result
    },
    setTownHallTypingStatus(state: any, status: any) {
      state.townHallTypingStatus = status
    },
    setLoadingTownhallTable(state: any, result: any) {
      state.loadingTownHallTable = result
    },
    setAdviser(state: any, result: any) {
      state.adviser = result
    },
    setCreator(state: any, result: any) {
      state.creator = result
    },
    setHuddleTag(state: any, result: any) {
      state.huddleTagData = result
    },
    setComment(state: any, result: any) {
      state.comment = result
    },
    setMembersPoll(state: any, result: any) {
      state.membersPoll = result
    },
    setCommentID(state: any, result: any) {
      state.commentId = result
    },
    setUserAll(state: any, result: any) {
      state.userAll = result
    },
    setMember(state: any, result: any) {
      state.member = result
    },
    setOrganization1level(state:any, result:any) {
      state.organization1level = result
    },
    setScheduledTownhall(state: any, result: any) {
      state.scheduledTownhall = result
    },
    setDraftTownhall(state: any, result: any) {
      state.draftTownhall = result
    },
  },
  actions: {
    async getTownhallTags({ commit, rootState }: any) {
      const company = rootState && rootState.authen && rootState.authen.user ? rootState.authen.user.company : null;
      if (!company) return;
      const snap = await firebase.firestore().collection('townhall_tags').doc(company).get();
      commit('SET_TOWNHALL_TAGS', snap.exists ? snap.data() : { tags: {} });
    },
    getTownhall({ commit, rootState, state }: any){
      const dateNow = new Date()
      const months: Array<any> = [];
      const months16: Array<any> = [];
      const yearnow = format(dateNow, 'YYYY')
      //const universities_by_month: Array<any> = [];
      for(let x=0; x<6; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      for(let x=0; x<16; x++){
          const enddate = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY-MM')
          const year = format(endOfMonth(addMonths(dateNow, -x)), 'YYYY')
          if(yearnow !== year){
              months16[enddate] = {
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM ‘YY'),
                  value:0
              }
          }else{
              months16[enddate] = { 
                  month:format(endOfMonth(addMonths(dateNow, -x)), 'MMM'),
                  value:0
              }
          }
      }
      
      return new Promise(( res, rej ) => {
          firebase.firestore().collection('townhall').where("company", "==", rootState.authen.user.company).where('delete','in',[false,'huddles']).orderBy('create_date','desc').get()
          .then(async (querySnapshot)=> {
              const townhalls: Array<any> = [];
              let all_townhall = 0;
              let all_townhall16 = 0;
              const townhallall: Array<any> = [];
              querySnapshot.forEach((doc) => {
                  const arrFile: Array<any> = [];
                  const arrFileOld: Array<any> = [];
                  const townhall = doc.data()
                 
                  if (townhall !== undefined){
                      if(townhall.files !== undefined){
                          for(const x in townhall.files){
                              townhall.files[x]['category'] = 'file'
                              arrFile.push(townhall.files[x]);
                              arrFileOld.push(townhall.files[x]);
                          }
                      }
                      if(townhall.images !== undefined){
                          for(const x in townhall.images){
                              townhall.images[x]['category'] = 'image'
                              if(townhall.images[x]['size'] !== undefined){
                                  arrFile.push(townhall.images[x]);
                                  arrFileOld.push(townhall.images[x]);
                              }
                          }
                      }
                  }
                  if(townhall.commentsall !== undefined){
                    townhall.new_comments = townhall.commentsall
                  }else{
                    townhall.new_comments = townhall.comments
                  }
                  townhall.key = doc.id
                  
                  // Only truncate names for regular users, preserve full names for Happily Characters
                  const isHappilyCharacter = townhall.create_user === 'happily_charracter' || 
                                           townhall.create_user === 'happily_character' ||
                                           (townhall.happily_user && townhall.happily_user !== '');
                  
                  if (!isHappilyCharacter) {
                    const name = townhall.create_name.split(' ')
                    townhall.create_name = `${name[0]} ` +(name[1]?`${name[1].charAt(0)}`:'')
                  }
                  // If it's a Happily Character, keep the full name as-is
                  
                  townhall.createdate = format(townhall.create_date, 'MMM D, YYYY [at] H:mm A');
                  townhall.arrFile = new Array()
                  if(arrFile.length > 0){
                      townhall.arrFile = _.orderBy(arrFile, ['update_date'], ['asc'])
                  }
                  townhall.arrFileOld = new Array()
                  if(arrFileOld.length > 0){
                      townhall.arrFileOld = _.orderBy(arrFileOld, ['update_date'], ['asc'])
                  }
                  if(townhalls.length < 4)
                  townhalls.push(townhall)
                  townhallall.push(townhall)
                  const d = townhall.create_date.split(' ');
                  const date = d[0].split('-');
                  const enddate = format(new Date(date[0],(date[1]-1),date[2]), 'YYYY-MM')
              
                  if(months[enddate] !== undefined){
                      months[enddate].value ++;
                      all_townhall ++;
                
                      if(townhall.votes){
                        months[enddate].value=months[enddate].value+townhall.votes
                      }
                  }
                  if(months16[enddate] !== undefined){
                      months16[enddate].value ++;
                      
                      if(townhall.votes){
                        months16[enddate].value=months16[enddate].value+townhall.votes
                      }
                      
                     
                  }
                  all_townhall16 ++;
              });
              await firebase.firestore().collectionGroup('comments').where('company','==',rootState.authen.user.company).where('type','==','townhall').get()
              .then((querySnapshotGroup)=> {
                  querySnapshotGroup.forEach((doc) => {
                    
                      const d = doc.data().createdate.split(' ');
                      const date = d[0].split('-');
                      const enddate = format(new Date(date[0],(date[1]-1),date[2]), 'YYYY-MM');
                      if(months[enddate] !== undefined){
                          months[enddate].value ++;
                          all_townhall ++;
                      }
                      if(months16[enddate] !== undefined){
                          months16[enddate].value ++;
                          
                      }
                      all_townhall16 ++;
                  });
              });
              // console.log('months',months)
           
              commit('setAllTownhall', all_townhall16)
              commit('setAllTownhall16', all_townhall16)
              commit('setTownhallGraphMonth', months)
              commit('setTownhallGraphMonth16', months16)
              commit('setTownhall', townhalls)
              commit('setTownhallAll', townhallall)
              commit("setTownHallShowing", townhallall.slice(0, state.size_page));
              commit("setTownHallResults", townhallall.length);
              commit('setLoadingTownhallTable', false)
              res();
          });
      });
    },
    townHallTopicSort({ commit, state }: any, value: any) {
      // let topicsPolls: Array<any> = [];
      // topicsPolls.push(state.townhall_all)
      // let textSearching = value[3] || state.inputSearchTownhall;
      // if (textSearching.length > 0) {
      //   if (topicsPolls.length > 0) {
      //     let re = new RegExp(textSearching, 'gi')
      //     let response = _.filter(topicsPolls[0], (item): any => {
      //       if (item.title.match(re)) {
      //         return true
      //       } else if (item.create_name != undefined && item.create_name.match(re)) {
      //         return true
      //       }
      //     });
      //     topicsPolls = []
      //     topicsPolls.push(response)
      //   }
      // }

      let field = value[0]
      commit('setTownHallSortField', field)
      let order = value[1]
      commit('settownHallSortOrder', order)

      // let newTownHalls = {}
      // for (let i = 0; i < topicsPolls[0].length; i++) {
      //   newTownHalls[i] = topicsPolls[0][i]
      //   let time = topicsPolls[0][i].create_date
      //   let create_date = time.split(" at").join(",")
      //   newTownHalls[i].timestamp = new Date(create_date.substring(0, create_date.length - 3)).getTime()
      // }
      // if (field === "read" || field === "new_comments" || field === "create_date") {
      //   if (order === "ascending") {
      //     order = 'desc'
      //   } else {
      //     order = 'asc'
      //   }
      // } else {
      //   if (order === "ascending") {
      //     order = 'asc'
      //   } else {
      //     order = 'desc'
      //   }
      // }
      // if (field === "class_datetime" || field === "") {
      //   field = "timestamp"
      // }
      // let _users = _.orderBy(newTownHalls, [field], [order]);
      // commit('setTownHallResults', _users.length)
      // commit('setTownHallShowing', _users.slice(0, state.size_page))
    },
    searchTownHallsTownHall({ commit, state, dispatch }: any, data: any) {
      clearTimeout (state.townHallTypingStatus)
      state.townHallTypingStatus = setTimeout(() => {
        commit('setTownHallPage', 1)
        commit('setTownHallTypingStatus', false)
        
        if (data.value && data.value.length > 0) {
          commit('setInputSearchTownhall', data.value);
          let townHallsSorted = state.townhall_all;
          let size = state.size_page
          let page = state.townHallPage
          let townHallsPageShowing: Array<any> = [];
          if (data.value && data.value.length > 1) {
            let re = new RegExp(data.value, 'gi')
            let response = _.filter(townHallsSorted, (item): any => {
              if (item.title.match(re)) {
                return true
              } else if (item.title != undefined && item.title.match(re)) {
                return true
              } else if (item.title != undefined && item.title.match(re)) {
                return true
              }
            });
            townHallsPageShowing = response
          } else {
            townHallsPageShowing = townHallsSorted
          }
          commit("setTownHallResults", townHallsPageShowing.length);
        }

        // else if (data.value.length == 0) {
        //   let townhall: Array<any> = [];
        //   townhall = state.townhall_all
        //   commit('setTownhall', townhall)
        //   // commit('setTownHallShowing', townhall.slice(0, state.size_page))
        // }
        commit('setTownHallTypingStatus', true)
      }, data.typingTimeout)
    },
    currentTopicsChange({ commit, state }: any, page: any) {
      // let size = state.size_page
      // let start_row = (page - 1) * size
      // let end_row = ((page - 1) * size) + size
      // let topics: Array<any> = [];
      // if (state.inputSearchTownhall.length > 0) {
      //   let re = new RegExp(state.inputSearchTownhall, 'gi')
      //   let response = _.filter(state.townhall_all, (item): any => {
      //     if (item.title.match(re)) {
      //       return true
      //     } else if (item.create_name != undefined && item.create_name.match(re)) {
      //       return true
      //     }
      //   });
      //   topics = response
      // } else {
      //   topics = state.townhall_all
      // }

      // let showDataInTable = topics.slice(start_row, end_row)
      commit('setTownHallPage', page)
      // commit('setTownHallShowing', showDataInTable)
    },
    async deleteTopic({commit,rootState,dispatch,state}:any,form:any){
      let data = form
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      firebase.firestore().collection('townhall').doc(data.key).update({
        delete: true
      }).then(docRef => {
        dispatch('getTownhall')
      });
    },
    // Pin/unpin a live post from the inbox console. Takes an explicit `pined`
    // boolean (not a toggle) so a double-click can't race on stale state, then
    // refetches so getters + the reader reflect the new state. Mirrors the
    // single-field update shape of deleteTopic. Field name `pined` matches the
    // canonical spelling RN and the townhall query already read.
    async setPinnedPost({dispatch}:any, obj:any){
      await firebase.firestore().collection('townhall').doc(obj.id).update({
        pined: !!obj.pined
      })
      return dispatch('getTownhall')
    },
    async editTopic({commit,rootState,dispatch,state}:any,obj:any){
      let data:any = obj.form
      let topic_id:any = obj.id
      let arrFileOld:any = data.arrFileOld
      let huddles=obj.huddles
      const __h1 = buildHuddleSave(huddles, state.huddleTag)
      let huddle:Array<any> = __h1.huddle
      let filter:any = __h1.filter
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      if(topic_id){
      // Handle creator information similar to createTopic
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      var response = data.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      var listData = _.find(state.creator, (item): any => {
        return item.name==data.creator
      });
      
      let topic ={
        title: data.title,
        ...markdownFields(data.description),
        type: 'topic',
        comment_disable: !data.commentEnabled,
        company: rootState.authen.user.company,
        delete:filter?false:"huddles",
        update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        // Add creator fields to preserve Happily Character information
        create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
        create_user: response? 'happily_charracter': rootState.authen.user.email,
        happily_user: response?listData.characterpath:"",
        email_create: rootState.authen.user.email,
      }
      if(!filter){
        topic["huddles"]=huddle
       }else{
        firebase.firestore().collection('townhall').doc(topic_id).update({huddles: firebase.firestore.FieldValue.delete()})
       }
       
      // Clean up fields when not a Happily Character post
      if(!response){
        delete topic.happily_user;
        delete topic.email_create;
      }
      // Keep an edited draft a draft (true unpublish preserved); publishing
      // stays an explicit action. topic.delete currently holds the would-be
      // audience (false | 'huddles'); stash it for republish, then mark draft.
      if(obj.asDraft){
        topic["draft_prev_delete"] = topic.delete
        topic["status"] = 'draft'
        topic["delete"] = 'draft'
      }
        firebase.firestore().collection('townhall').doc(topic_id).update(topic).then(() => {
          const files: Array<any> = [];
          const images: Array<any> = [];
          if(data.fileList.length > 0){
            let datacount = 0;
            let count = 1;
            for (const x in data.fileList) {
              if(data.fileList[x].ckfile === undefined){
                const category = data.fileList[x].raw.type.split("/");
                data.fileList[x].category = (category[0] == 'image')?'image':'file';
                firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/${data.fileList[x].category}/${data.fileList[x].name}`)
                .put((data.fileList[x].raw)).then((success)=>{
                  if(success.state === 'success'){
                    firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/${data.fileList[x].category}/${data.fileList[x].name}`).getDownloadURL().then(downloadURL => {
                      if(data.fileList[x].category === 'image'){
                        images.push({
                          name: data.fileList[x].name,
                          size: data.fileList[x].size,
                          url: downloadURL,
                          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        });
                      }else{
                        files.push({
                          name: data.fileList[x].name,
                          size: data.fileList[x].size,
                          url: downloadURL,
                          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        });
                      }
                      data.fileList[x].ckfile = 'old';
                      data.fileList[x].url = downloadURL;
                      arrFileOld.push(data.fileList[x]);
                      datacount = files.length + images.length;
                      if(data.fileList.length === datacount){
                        const update = {
                          images: _.orderBy(images, ['update_date'], ['asc']),
                          files: _.orderBy(files, ['update_date'], ['asc'])
                        }
                        if(files.length === 0) update['pdfimages'] = [];
                        if(files.length > 0) update['status'] = 'gen';
                        if(images.length > 0) update['status_images'] = 'gen';
                        firebase.firestore().collection('townhall').doc(topic_id).update(update);
                      }
                    });
                  }
                }).catch((error) => {
                  
                });
              }else{
                  if(data.fileList[x].category === 'image'){
                    images.push({
                        name: data.fileList[x].name,
                        size: data.fileList[x].size,
                        url: data.fileList[x].url,
                        update_date: data.fileList[x].update_date,
                    });
                  }else{
                    files.push({
                        name: data.fileList[x].name,
                        size: data.fileList[x].size,
                        url: data.fileList[x].url,
                        update_date: data.fileList[x].update_date,
                    });
                  }
                  datacount = files.length + images.length;
                  if(data.fileList.length === datacount){
                    const update = {
                      images: _.orderBy(images, ['update_date'], ['asc']),
                      files: _.orderBy(files, ['update_date'], ['asc'])
                    }
                    if(files.length === 0) update['pdfimages'] = [];
                    if(files.length > 0) update['status'] = 'gen';
                    if(images.length > 0) update['status_images'] = 'gen';
                    firebase.firestore().collection('townhall').doc(topic_id).update(update);
                  }
              }
              if(data.fileList.length === count){
                  if(arrFileOld.length > 0){
                      let i = 1;
                      for (const x in arrFileOld) {
                          if(arrFileOld[x].name !== undefined && arrFileOld[x].category !== undefined){
                              const ckdel:any = _.findIndex(data.fileList, (o:any) => { return o.name == arrFileOld[x].name; });
                              if(ckdel && ckdel * 1 < 0){
                                  firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/${arrFileOld[x].category}/${arrFileOld[x].name}`).getDownloadURL().then(downloadURL => {
                                      if(downloadURL !== undefined && downloadURL !== ''){
                                        firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/${arrFileOld[x].category}/${arrFileOld[x].name}`).delete();
                                      }
                                  });

                                  if(arrFileOld[x].category === 'file'){
                                    // firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/${arrFileOld[x].name}_0.jpg`).getDownloadURL().then(downloadURL2 => {
                                    //       if(downloadURL2 !== undefined && downloadURL2 !== ''){
                                    //         firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/${arrFileOld[x].name}_0.jpg`).delete();
                                    //       }
                                    //   });
                                  }else if(arrFileOld[x].url_small != undefined && arrFileOld[x].url_small != '' && arrFileOld[x].category === 'image'){
                                    firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/small/${arrFileOld[x].name}`).getDownloadURL().then(downloadURL3 => {
                                          if(downloadURL3 !== undefined && downloadURL3 !== ''){
                                            firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/small/${arrFileOld[x].name}`).delete();
                                          }
                                      });
                                  }

                                  if(arrFileOld.length === i){
                                    setTimeout(() => {
                                      dispatch('getTownhall')
                                    }, 500);
                                  }
                              }else{
                                  if(arrFileOld.length === i){
                                    setTimeout(() => {
                                      dispatch('getTownhall')
                                    }, 500);
                                  }
                              }
                          }
                          i++;
                      }
                  }else{
                    dispatch('getTownhall')
                  }
              }
              count++;
            }
          }else{

            let topic ={
              title: data.title,
              ...markdownFields(data.description),
              type: 'topic',
              comment_disable: !data.commentEnabled,
              company: rootState.authen.user.company,
              delete:filter?false:"huddles",
              update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            }
            if(!filter){
              topic["huddles"]=huddle
             }else{
              firebase.firestore().collection('townhall').doc(topic_id).update({huddles: firebase.firestore.FieldValue.delete()})
             }
              firebase.firestore().collection('townhall').doc(topic_id).update(topic);
              if(arrFileOld.length > 0){
                  let datacount = 1;
                  for (const x in arrFileOld) {
                      firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/${arrFileOld[x].category}/${arrFileOld[x].name}`).delete().then(()=>{
                          //del file convert image
                          // if(arrFileOld[x].category === 'file'){
                          //   firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/${arrFileOld[x].name}_0.jpg`).delete();
                          // }

                          if(arrFileOld[x].url_small != undefined && arrFileOld[x].url_small != '' && arrFileOld[x].category === 'image'){
                            firebase.storage().ref(`townhall/${rootState.authen.user.company}/${topic_id}/image/small/${arrFileOld[x].name}`).delete();
                          }
                          if(arrFileOld.length === datacount){
                            const update = {
                              images: [],
                              files: [],
                              pdfimages: [],
                            }
                            firebase.firestore().collection('townhall').doc(topic_id).update(update).then(() => {
                              dispatch('getTownhall')
                            });
                          }
                          datacount++;
                      });
                  }
              }else{
                dispatch('getTownhall')
              }
          }
        })
      }
    },
    async createTopic({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      let huddles=obj.huddles
      const __h = buildHuddleSave(huddles, state.huddleTag)
      let huddle: any[] = __h.huddle
      let filter: any = __h.filter
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      const id = firebase.firestore().collection(`townhall`).doc().id;
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      var response = obj.form.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      var listData = _.find(state.creator, (item): any => {
        return item.name==obj.form.creator
        });
      const files: Array<any> = [];
      const images: Array<any> = [];
      if(data.fileList.length > 0){
        for (const x in data.fileList) {
          if(data.fileList[x].ckfile == 'old'){
            if(data.fileList[x].category === 'image'){
              images.push({
                name: data.fileList[x].name,
                size: data.fileList[x].size,
                url: data.fileList[x].url,
                update_date: data.fileList[x].update_date,
                duplicate: true,
                duplicatekey: obj.id,
              });
            }else{
              files.push({
                name: data.fileList[x].name,
                size: data.fileList[x].size,
                url: data.fileList[x].url,
                update_date: data.fileList[x].update_date,
                duplicate: true,
                duplicatekey: obj.id,
              });
            }
            data.fileList[x].ckfile = 'old';
            data.fileList[x].url = data.fileList[x].url;

            let datacount = files.length + images.length;
            if(data.fileList.length === datacount){
                var topic = {
                  title: data.title,
                  ...markdownFields(data.description),
                  type: 'topic',
                  comment_disable: !data.commentEnabled,
                  company: rootState.authen.user.company,
                  comments: 0,
                  create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                  create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
                  create_user:response? 'happily_charracter': rootState.authen.user.email,
                  happily_user:response?listData.characterpath:"",
                  // create_user: 'frame.yuranan@gmail.com', /*FIX*/
                  email_create:rootState.authen.user.email,
                  pined: false,
                  delete:filter?false:"huddles",
                  images: _.orderBy(images, ['update_date'], ['asc']),
                  files: _.orderBy(files, ['update_date'], ['asc']),
             
                }
                if(!filter){
                  topic["huddles"]=huddle
                }
                if(!response){
                  delete topic.happily_user;
                  delete topic.email_create
                }
                
                if(obj.id){
                  topic['duplicate'] = true
                  topic['duplicatekey'] = obj.id
                }
                if(files.length > 0) topic['status'] = 'gen';
                if(images.length > 0) topic['status_images'] = 'gen';
                if(response){
                  topic.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():"" 
                  }
             


                firebase.firestore().collection('townhall').doc(id).set(topic).then(docRef => {
                  dispatch('getTownhall')
                });
            }
          }else{
            const category = data.fileList[x].raw.type.split("/");
            data.fileList[x].category = (category[0] == 'image')?'image':'file';
            data.fileList[x].update_date = `${format(new Date(), 'DD/MM/YYYY HH:mm')}-${x}`;
            firebase.storage().ref(`townhall/${rootState.authen.user.company}/${id}/${data.fileList[x].category}/${data.fileList[x].name}`)
            .put((data.fileList[x].raw)).then((success)=>{
              if(success.state === 'success'){
                firebase.storage().ref(`townhall/${rootState.authen.user.company}/${id}/${data.fileList[x].category}/${data.fileList[x].name}`).getDownloadURL().then(downloadURL => {
                  if(data.fileList[x].category === 'image'){
                    images.push({
                      name: data.fileList[x].name,
                      size: data.fileList[x].size,
                      url: downloadURL,
                      update_date: data.fileList[x].update_date,
                    });
                  }else{
                    files.push({
                      name: data.fileList[x].name,
                      size: data.fileList[x].size,
                      url: downloadURL,
                      update_date: data.fileList[x].update_date,
                    });
                  }
                  data.fileList[x].ckfile = 'old';
                  data.fileList[x].url = downloadURL;

                  let datacount = files.length + images.length;
                  if(data.fileList.length === datacount){
                      let topic = {
                        title: data.title,
                        ...markdownFields(data.description),
                        type: 'topic',
                        comment_disable: !data.commentEnabled,
                        company: rootState.authen.user.company,
                        comments: 0,
                        create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
                        create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
                        create_user:response? 'happily_charracter': rootState.authen.user.email,
                        happily_user:response?listData.characterpath:"",
                        // create_user: 'frame.yuranan@gmail.com', /*FIX*/
                        email_create:rootState.authen.user.email,
                        pined: false,
                        delete:filter?false:"huddles",
                        images: _.orderBy(images, ['update_date'], ['asc']),
                        files: _.orderBy(files, ['update_date'], ['asc']),
                       
                      }
                      if(!filter){
                        topic["huddles"]=huddle
                      }
                      if(!response){
                        delete topic.happily_user;
                        delete topic.email_create
                      }
                      if(obj.id){
                        topic['duplicate'] = true
                        topic['duplicatekey'] = obj.id
                      }
                      if(files.length > 0) topic['status'] = 'gen';
                      if(images.length > 0) topic['status_images'] = 'gen';
                      if(response){
                        topic.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():"" 
                        }
                      // console.log("topic",topic)
                      firebase.firestore().collection('townhall').doc(id).set(topic).then(docRef => {
                        dispatch('getTownhall')
                      });
                  }
                });
              }
            }).catch((error) => {
            });
          }
        }
      }else{
        let topic = {
          title: data.title,
          ...markdownFields(data.description),
          type: 'topic',
          comment_disable: !data.commentEnabled,
          company: rootState.authen.user.company,
          comments: 0,
          create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
          create_user:response? 'happily_charracter': rootState.authen.user.email,
          happily_user:response?listData.characterpath:"",
          // create_user: 'frame.yuranan@gmail.com', /*FIX*/
          email_create:rootState.authen.user.email,
          pined: false,
          delete: filter?false:"huddles",
        }
        if(!filter){
          topic["huddles"]=huddle
        }
        if(!response){
          delete topic.happily_user;
          delete topic.email_create
        }
        if(obj.id){
          topic['duplicate'] = true
          topic['duplicatekey'] = obj.id
        }
        if(response){
          topic.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():""
          }
        firebase.firestore().collection('townhall').doc(id).set(topic).then(docRef => {
          dispatch('getTownhall')
        });
      }
    },
    getAdviser({commit,rootState,dispatch,state}:any,value:any){

      firebase.database().ref().child('users_adviser').orderByChild('company').equalTo(`${value.company}`).once('value', snapshot => {
        snapshot.forEach((doc):any => {
          const users_adviser = doc.val()
          if(users_adviser.email===value.email){
            commit('setAdviser',true)
          }
        })

      })
    },
    async getCreator({commit,rootState,dispatch,state}:any,value:any){
      var pic=null
      if (value.profilepic_small) {
        pic = value.profilepic_small;
      } else if (value.profilepic_crop) {
        pic = value.profilepic_crop;
      } else if (value.profilepic) {
        pic = value.profilepic;
      } else {
        pic = null;
      }
      var data:Array<any> = [{name:value.firstname + " " + value.lastname.charAt(0),pic:pic,character:false}];
      const categoryData=await getCategory()
      for(const key in categoryData){
        if(categoryData[key].status=="Y"){
         
            var _data =categoryData[key]
                _data.key = key;
                  if(!(_data.key == '-KxuZH3ki2YFeNBeNxu0' || _data.key == '-L1uMXKXRgCMnLHXThFK'||_data.key=='-Lcj5qQhH0T5OwGDiQfM'||_data.key=="-KxS3N5kloAYbGlYUwXO") ){
                    
                      data.push({..._data,name:_data.character_name+" ("+_data.category+")",pic:_data.characterpath,character:true});
                  }
        }
      }
      commit('setCreator',data)
    //   firebase.database().ref().child('category').orderByChild("status").equalTo("Y").once('value', snapshot => {
    //     snapshot.forEach((doc):any => {
    //       var _data = doc.val()
    //           _data.key = doc.key;
    //             if(!(_data.key == '-KxuZH3ki2YFeNBeNxu0' || _data.key == '-L1uMXKXRgCMnLHXThFK'||_data.key=='-Lcj5qQhH0T5OwGDiQfM'||_data.key=="-KxS3N5kloAYbGlYUwXO") ){
                  
    //                 data.push({..._data,name:_data.character_name+" ("+_data.category+")",pic:_data.characterpath,character:true});
    //             }
    //     })
    //     commit('setCreator',data)
    //  })
    },
    async createPoll({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      var options:Array<any>=[]
      var members:Array<any>=[]
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      const id = firebase.firestore().collection(`townhall`).doc().id;
      data.polls.map(value=>{
        members.push(0)
        options.push(value.poll)
      })

      var response = obj.form.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      let listData =_.find(state.creator, (item): any => {
        return item.name==obj.form.creator
        });

        let huddles=obj.huddles
        const __h = buildHuddleSave(huddles, state.huddleTag)
        let huddle: any[] = __h.huddle
        let filter: any = __h.filter

        let poll = {
          title: data.title,
          type: 'poll',
          comment_disable: !data.commentEnabled,
          company: rootState.authen.user.company,
          comments: 0,
          commentsall : 0,
          votes : 0,
          create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
          create_user:response? 'happily_charracter': rootState.authen.user.email,
          happily_user:response?listData.characterpath:"",
          email_create:rootState.authen.user.email,
          pined: false,
          delete:filter?false:"huddles",
          members:members,
          options:options,
          ...markdownFields(data.description)
        }
        if(!filter){
          poll["huddles"]=huddle
        }
        if(response){
          poll.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():"" 
          
        }else{
          delete poll.happily_user
          delete poll.email_create
        }
        firebase.firestore().collection('townhall').doc(id).set(poll).then(docRef => {
          dispatch('getTownhall')
        });
      
    },
    async editPoll({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      // console.log('data',data)
      var options:Array<any>=[]
      var member:Array<any>=[]
      let huddles=obj.huddles
      const __h1 = buildHuddleSave(huddles, state.huddleTag)
      let huddle:Array<any> = __h1.huddle
      let filter:any = __h1.filter
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      const id =  obj.id
      data.polls.map((value,index)=>{
        if(data.members[index]){
          member.push(data.members[index])
        }else{
          member.push(0)
        }
        options.push(value.poll)
      })
      var response = data.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      let listData =_.find(state.creator, (item): any => {
        return item.name==data.creator
        });

   

        let poll = {
          title: data.title,
          type: 'poll',
          comment_disable: !data.commentEnabled,
          company: rootState.authen.user.company,
          // comments: 0,
          // commentsall : 0,
          // votes : 0,
          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          //create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
          create_user:response? 'happily_charracter': rootState.authen.user.email,
          happily_user:response?listData.characterpath:"",
          email_create:rootState.authen.user.email,
          // pin state is preserved on edit (not overwritten) — see setPinnedPost
          delete:filter?false:"huddles",
          members:member,
          options:options,
          ...markdownFields(data.description || '')
        }
        if(!filter){
          poll["huddles"]=huddle
         }else{
          firebase.firestore().collection('townhall').doc(id).update({huddles: firebase.firestore.FieldValue.delete()})
         }   
        if(response){
          poll.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():"" 
          }
          else{
            delete poll.happily_user
            delete poll.email_create
          }
        if(obj.asDraft){
          poll["draft_prev_delete"] = poll.delete
          poll["status"] = 'draft'
          poll["delete"] = 'draft'
        }
        firebase.firestore().collection('townhall').doc(id).update(poll).then(docRef => {
          dispatch('getTownhall')
        });
    },
    async createChecklist({commit,rootState,dispatch,state}:any,obj:any){
      let data = obj.form
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      const id = firebase.firestore().collection(`townhall`).doc().id;
      // Drop empty rows + normalize to the canonical ChecklistItem shape
      // (label/type/required/description?/link?). Mirrors the RN write
      // contract added in commit 2a38985 so both ends speak one shape.
      const options = toWriteOptions(data.checklists)
      const members: Array<any> = options.map(() => 0)
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      var response = obj.form.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      var listData = _.find(state.creator, (item): any => {
        return item.name==obj.form.creator
        });


        let huddles=obj.huddles
        const __h = buildHuddleSave(huddles, state.huddleTag)
        let huddle: any[] = __h.huddle
        let filter: any = __h.filter
        let checklist: any = {
          title: data.title,
          type: 'checklist',
          description: (data.description || '').trim(),
          comment_disable: !data.commentEnabled,
          company: rootState.authen.user.company,
          comments: 0,
          commentsall : 0,
          votes : 0,
          create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
          create_user:response? 'happily_charracter': rootState.authen.user.email,
          happily_user:response?listData.characterpath:"",
          email_create:rootState.authen.user.email,
          pined: false,
          delete: filter?false:"huddles",
          members:members,
          options:options,
          reminder_day :data.weeklyCofig.day,
          reminder_time:data.weeklyCofig.time,
          reminder :data.weeklyReminders,
          respondents : data.showRespondentsResults,
        }
        // Additive program-friendly fields. Older RN clients ignore
        // unknown keys; the normalizer covers the items[] shape change.
        if (data.dueDate) {
          checklist.due_date = data.dueDate
          checklist.reminder_relative = Array.isArray(data.reminderRelative)
            ? data.reminderRelative
            : []
        }
        if (Array.isArray(data.tags) && data.tags.length > 0) {
          checklist.tags = data.tags
        }
        if(!filter){
          checklist["huddles"]=huddle
        }
        if(response){
          checklist.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():"" 
          }
          else{
            delete checklist.happily_user
            delete checklist.email_create
          }
        firebase.firestore().collection('townhall').doc(id).set(checklist).then(docRef => {
          dispatch('getTownhall')
        });
      
    },
    async editChecklist({commit,rootState,dispatch,state}:any,obj:any){

      let data = obj.form
      commit('setTownHallShowing', [])
      commit('setLoadingTownhallTable', true)
      const id =obj.id
      // Normalize + drop empty rows. members[] stays index-aligned with
      // options[] so per-item response counts survive an edit. Rows that
      // had a count get to keep it; new rows start at 0.
      const options = toWriteOptions(data.checklists)
      const members: Array<any> = data.checklists
        .filter((row: any) => (row && (row.label || row.list) || '').toString().trim().length > 0)
        .map((_row: any, index: number) =>
          (data.members && data.members[index]) ? data.members[index] : 0
        )
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      var response = data.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      var listData = _.find(state.creator, (item): any => {
        return item.name==data.creator
        });


        let huddles=obj.huddles
        const __h = buildHuddleSave(huddles, state.huddleTag)
        let huddle: any[] = __h.huddle
        let filter: any = __h.filter
        let checklist: any = {
          title: data.title,
          type: 'checklist',
          description: (data.description || '').trim(),
          comment_disable: !data.commentEnabled,
          company: rootState.authen.user.company,
          // comments: 0,
          // commentsall : 0,
          // votes : 0,
          update_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          //create_date: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
          create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
          create_user:response? 'happily_charracter': rootState.authen.user.email,
          happily_user:response?listData.characterpath:"",
          // pin state is preserved on edit (not overwritten) — see setPinnedPost
          delete:filter?false:"huddles",
          members:members,
          options:options,
          reminder_day :data.weeklyCofig.day,
          reminder_time:data.weeklyCofig.time,
          reminder :data.weeklyReminders,
          respondents : data.showRespondentsResults,
        }
        // Additive program-friendly fields. Cleared values use
        // FieldValue.delete() so RN doesn't keep reading stale keys.
        if (data.dueDate) {
          checklist.due_date = data.dueDate
          checklist.reminder_relative = Array.isArray(data.reminderRelative)
            ? data.reminderRelative
            : []
        } else {
          checklist.due_date = firebase.firestore.FieldValue.delete()
          checklist.reminder_relative = firebase.firestore.FieldValue.delete()
        }
        if (Array.isArray(data.tags) && data.tags.length > 0) {
          checklist.tags = data.tags
        } else {
          checklist.tags = firebase.firestore.FieldValue.delete()
        }

        if(!filter){
          checklist["huddles"]=huddle
         }else{
          firebase.firestore().collection('townhall').doc(id).update({huddles: firebase.firestore.FieldValue.delete()})
         }
        if(response){
          checklist.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():""
          }
          else{
            delete checklist.happily_user
          }
        if(obj.asDraft){
          checklist["draft_prev_delete"] = checklist.delete
          checklist["status"] = 'draft'
          checklist["delete"] = 'draft'
        }
        firebase.firestore().collection('townhall').doc(id).update(checklist).then(docRef => {
          dispatch('getTownhall')
        });
      
    },
    async getHouseAndTeam({commit,rootState,dispatch,state}:any,obj:any){

      let huddleTagData:Array<any> =[
        {
          value: "everyone",
          label: "Everyone",
        },
        {
          value: PROGRAM_ONLY_KEY,
          label: PROGRAM_ONLY_LABEL,
        },
      ]


      // firebase.database().ref('team').orderByChild("company").equalTo(`${rootState.authen.user.company}`).once('value', snapshot => {
          
        // snapshot.forEach((arrData):any => {
        const teams = await getTeamByCompany(rootState.authen.user.company)//rootState.main.allTeam// (await firebase.database().ref('team').orderByChild("company").equalTo(user.company).once('value')).val()
          //console.log("teams",teams)
          for(let i in teams){
          
          const u = teams[i]
          u.key = i
           u.value =teams[i].name
          let data={
            value:  i,
            label:  u.name ,
            type:'team'
          }
          if(i){
            state.huddleTag[i]=data
          }
          
          huddleTagData.push(data);
          
        }

      // })
      firebase.database().ref('houses').once('value', (snapshot) => {
        snapshot.forEach((childSnapshot) => {
            var _data = childSnapshot.val();
            _data.key = childSnapshot.key;
            let data={
              value:  childSnapshot.key ,
              label:  _data.name ,
              type:'houses'
            }
            if(childSnapshot.key){
              state.huddleTag[childSnapshot.key]=data
            }
            huddleTagData.push(data);
        })
        // Pin Everyone + Program only to the top — _.sortBy with mixed
        // defined/undefined keys would otherwise bury the untyped
        // entries at the bottom.
        const [special, typed] = _.partition(huddleTagData, (e: any) => !e.type);
        huddleTagData = [...special, ..._.sortBy(typed, ['type', 'label'])];
        commit('setHuddleTag', huddleTagData)

      })
    },
    async getComment({commit,rootState,dispatch,state}:any,obj:any){
      let comment:Array<any>=[]
      await firebase.firestore().collection(`townhall/${obj.id}/comments`).get()
          .then((querySnapshot)=> {
              querySnapshot.forEach((doc) => {
                  let townhall = doc.data()
                  townhall.key = doc.id
               
                  let liked=_.find(townhall.likeusers, function(o) { return o==rootState.authen.user.email });
                  if(liked){
                    townhall.liked=true
                  }else{
                    townhall.liked=false
                  }
                  if(state.userAll[townhall.user]){
                    
                    townhall.creatorImageProfile=state.userAll[townhall.user].profilepic_crop||""
                  }else{
                    townhall.creatorImageProfile=""
                  }
                  
                  let subComment:Array<any>=[]
                  if(townhall.comments>0){
                    firebase.firestore().collection(`townhall/${obj.id}/comments/${doc.id}/comments`).get()
                    .then((_querySnapshot)=> {
                        _querySnapshot.forEach((_doc) => {
                            const _townhall = _doc.data()
                            _townhall.key = _doc.id
                            let _liked=_.find(_townhall.likeusers, function(o) { return o==rootState.authen.user.email });
                            
                            if(state.userAll[_townhall.user]){
                              _townhall.creatorImageProfile=state.userAll[_townhall.user].profilepic_crop||""
                            }else{
                              _townhall.creatorImageProfile=""
                            }

                            if(_liked){
                              _townhall.liked=true
                            }else{
                              _townhall.liked=false
                            }
                            subComment.push(_townhall)
                            
                    })

                    const _subComment=_.orderBy(subComment, [(obj) => {return new Date(obj.createdate)}], ['asc'])
                   
                    comment.push({...townhall,subComment:_subComment})
                  })
                    
                }else{
                  
                  comment.push({...townhall,subComment:[]})
                }
                  
          })
          commit('setComment',comment)
    })
    },
    async getMembersPoll({commit,rootState,dispatch,state}:any,obj:any){
      let members:Array<any>=[]
      await firebase.firestore().collection(`townhall/${obj.id}/members`).get()
      .then((querySnapshot)=> {
        querySnapshot.forEach((doc) => {
          let townhall = doc.data()
          townhall.key = doc.id
          if(members[townhall.vote] == undefined){
            members[townhall.vote] = []
          }
          members[townhall.vote].push(townhall.key)
        })
        commit('setMembersPoll',members)
      })
    },
    async replyComment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.townhallId,
        maprent_id2:obj.comment.key,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications: obj.notifications?obj.notifications:[],
        type: "townhall",
        user: rootState.authen.user.email,
        value:obj.message}
    await firebase.firestore().collection(`townhall/${obj.townhallId}/comments/${obj.comment.key}/comments`).add(data).then(()=>{
      //dispatch('getTownhall')
    });
    },
    async comment({commit,rootState,dispatch,state}:any,obj:any){
      let data={
        comments: 0,
        company: rootState.authen.user.company,
        createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        like: 0,
        likeorder:obj.likeorder,//parseInt('9999'+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss")),
        mparent_id:obj.townhallId,
        name:rootState.authen.user.firstname+" "+rootState.authen.user.lastname.charAt(0),
        notifications:  obj.notifications?obj.notifications:[],
        type: "townhall",
        user: rootState.authen.user.email,
        value:obj.message}
      await firebase.firestore().collection(`townhall/${obj.townhallId}/comments`).add(data).then((docRef)=>{
        // state.commentId=docRef.id
        commit('setCommentID',docRef.id)
        //dispatch('getTownhall')
      })
    },
    async likeOrUnLike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){

          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`townhall/${obj.form.mparent_id}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          
        const docref =await firebase.firestore().collection(`townhall/${obj.form.mparent_id}/comments`).doc(obj.form.key);
     
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    async replylikeOrUnlike({commit,rootState,dispatch,state}:any,obj:any){
        let like =obj.form.like;
        let likeorder = obj.form.likeorder;

        if(obj.form.liked === true){
          like = like-1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))+1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
          var docref =await firebase.firestore().collection(`townhall/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);

          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayRemove(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(-1),
            likeorder:likeorder
          });
        }else{

          like = like+1;
          const likeordertmp = likeorder.toString().substring(0, 4);
          likeorder = parseInt(String((Number(likeordertmp))-1)+moment().utc().add(rootState.authen.user.timezone,'hours').format("YYYYMMDDHHmmss"));
        const docref =await firebase.firestore().collection(`townhall/${obj.form.mparent_id}/comments/${obj.form.maprent_id2}/comments`).doc(obj.form.key);
          docref.update({
            likeusers:firebase.firestore.FieldValue.arrayUnion(rootState.authen.user.email),
            like:firebase.firestore.FieldValue.increment(1),
            likeorder:likeorder
          });
        }
   
    },
    getUser({commit,rootState,dispatch,state}:any,obj:any){
      let userAll={}
      let member:Array<any>=[]
      for (const doc in rootState.main.allUser){
        let data=rootState.main.allUser[doc]
        if(data.email){
          userAll[data.email]=data
         
        }
        data.fullname=data.firstname+" "+data.lastname
        data.name=data.firstname+" "+data.lastname
        data.id=doc
        member.push(data)
        
      }
      commit('setMember',member)
      commit('setUserAll',userAll)
      // firebase.database().ref(`users`).orderByChild("company").equalTo(rootState.authen.user.company).once('value', snapshot => {
      //   snapshot.forEach((doc):any => {
           
      //   });
      //   //console.log("member",member)
       
      // })
    },        
    getChildren({ commit, rootState, state, dispatch }: any, key: any){
      const organization1level: { [key: string]: string } = {};
       firebase.firestore().collection('organization1level').where("company", "==", rootState.authen.user.company).get()
          .then(function (querySnapshot) {
              querySnapshot.forEach(function (doc) {
                     if(doc.data().team_id){
                      organization1level[doc.data().team_id]=doc.data().parent
                     }
                      
              })
              commit('setOrganization1level',organization1level)
          })
    },
    async scheduleTownhallPost({ commit, rootState, dispatch, state }: any, obj: any){
      // v1: only topics can be scheduled. Park the doc in `townhall_scheduled`
      // (no employee client reads this collection); a separate scheduler
      // promotes it into `townhall` at publish time and stamps create_date.
      if(obj.type !== 'topic'){
        return Promise.reject(new Error('Only topics can be scheduled in v1'))
      }
      let data = obj.form
      let huddles = obj.huddles
      const publishAt = obj.publishAt
      const __h = buildHuddleSave(huddles, state.huddleTag)
      let huddle: any[] = __h.huddle
      let filter: any = __h.filter
      var name=`${rootState.authen.user.firstname} ${rootState.authen.user.lastname}`
      var response = obj.form.creator===rootState.authen.user.firstname+ " " + rootState.authen.user.lastname.charAt(0)?false:true
      var listData = _.find(state.creator, (item): any => {
        return item.name==obj.form.creator
        });
      // Mirror the no-attachment topic payload from createTopic, but omit
      // create_date (the scheduler sets it at publish).
      let topic: any = {
        title: data.title,
        ...markdownFields(data.description),
        type: 'topic',
        comment_disable: !data.commentEnabled,
        company: rootState.authen.user.company,
        comments: 0,
        create_name: response?((listData && listData.character_name)?listData.character_name.toString():""):(name?name.toString():""),
        create_user:response? 'happily_charracter': rootState.authen.user.email,
        happily_user:response?listData.characterpath:"",
        email_create:rootState.authen.user.email,
        pined: false,
        delete: filter?false:"huddles",
      }
      if(!filter){
        topic["huddles"]=huddle
      }
      if(!response){
        delete topic.happily_user;
        delete topic.email_create
      }
      if(response){
        topic.create_name = (listData && listData.character_name) ? listData.character_name.toString() : (name) ? name.toString():""
      }
      // Scheduling metadata layered on top of the topic payload.
      const scheduledDoc = {
        ...topic,
        publish_at: firebase.firestore.Timestamp.fromDate(publishAt),
        publish_at_str: format(publishAt, 'YYYY-MM-DD HH:mm:ss'),
        status: 'scheduled',
        scheduled_by: rootState.authen.user.email,
        scheduled_at: firebase.firestore.FieldValue.serverTimestamp(),
      }
      const id = firebase.firestore().collection('townhall_scheduled').doc().id
      await firebase.firestore().collection('townhall_scheduled').doc(id).set(scheduledDoc)
      return dispatch('getScheduledTownhall')
    },
    async getScheduledTownhall({ commit, rootState }: any){
      const user = rootState && rootState.authen ? rootState.authen.user : null
      const company = user ? user.company : null
      if(!company){
        commit('setScheduledTownhall', [])
        return
      }
      const querySnapshot = await firebase.firestore().collection('townhall_scheduled')
        .where('company', '==', company).get()
      const scheduled: Array<any> = []
      querySnapshot.forEach((doc: any) => {
        scheduled.push({ ...doc.data(), key: doc.id })
      })
      // Ascending by publish_at (Firestore Timestamp -> .seconds); guard missing.
      scheduled.sort((a: any, b: any) => {
        const as = a.publish_at && a.publish_at.seconds != null ? a.publish_at.seconds : Infinity
        const bs = b.publish_at && b.publish_at.seconds != null ? b.publish_at.seconds : Infinity
        return as - bs
      })
      commit('setScheduledTownhall', scheduled)
    },
    async cancelScheduledPost({ dispatch }: any, obj: any){
      await firebase.firestore().collection('townhall_scheduled').doc(obj.id).delete()
      await dispatch('getScheduledTownhall')
    },
    // Drafts are unpublished posts kept in the live `townhall` collection with
    // delete:'draft' — out of the app's [false,'huddles'] live query, so the RN
    // app never shows them with no app change. Equality-only filter (no
    // orderBy) so Firestore needs no new composite index; sort client-side
    // since drafts are few.
    async getDraftTownhall({ commit, rootState }: any){
      const user = rootState && rootState.authen ? rootState.authen.user : null
      const company = user ? user.company : null
      if(!company){
        commit('setDraftTownhall', [])
        return
      }
      const querySnapshot = await firebase.firestore().collection('townhall')
        .where('company', '==', company).where('delete', '==', 'draft').get()
      const drafts: Array<any> = []
      querySnapshot.forEach((doc: any) => {
        drafts.push({ ...doc.data(), key: doc.id })
      })
      drafts.sort((a: any, b: any) =>
        String(b.create_date || '').localeCompare(String(a.create_date || '')))
      commit('setDraftTownhall', drafts)
    },
    // Unpublish a live post in place: delete:'draft' drops it from the app feed;
    // draft_prev_delete remembers the would-be-published audience so republish
    // restores it; a draft must not sit pinned. Comments/reads stay under the
    // doc untouched.
    async moveToDraft({ dispatch }: any, obj: any){
      const ref = firebase.firestore().collection('townhall').doc(obj.id)
      const snap = await ref.get()
      const prev: any = snap.exists ? snap.data() : {}
      const prevDelete = (prev && prev.delete === 'huddles') ? 'huddles' : false
      await ref.update({
        status: 'draft',
        delete: 'draft',
        draft_prev_delete: prevDelete,
        pined: false,
      })
      await dispatch('getTownhall')
      await dispatch('getDraftTownhall')
    },
    // Reverse of moveToDraft: restore the saved audience (fallback: infer from
    // the huddles array), mark published, drop the bookkeeping field.
    async republishPost({ dispatch }: any, obj: any){
      const ref = firebase.firestore().collection('townhall').doc(obj.id)
      const snap = await ref.get()
      const data: any = snap.exists ? snap.data() : {}
      const restore = (data.draft_prev_delete != null)
        ? data.draft_prev_delete
        : (Array.isArray(data.huddles) && data.huddles.length ? 'huddles' : false)
      await ref.update({
        status: 'published',
        delete: restore,
        draft_prev_delete: firebase.firestore.FieldValue.delete(),
      })
      await dispatch('getTownhall')
      await dispatch('getDraftTownhall')
    },


  },
  getters: {
    townhallTags: (state: any) => state.townhallTags,
    townHalls: (state) => {
      // return townHalls
      let townHalls = state.townhall_all
      let inputSearchTownhall = state.inputSearchTownhall
      let newTownHalls = {}
      let field = state.townHallSortField
      let order = state.townHallSortOrder
      for (let i = 0; i < townHalls.length; i++) {
        newTownHalls[i] = townHalls[i]
        // let time = townHalls[i].class_datetime
        // let class_datetime = time.split(" at").join(",")
        // newTownHalls[i].timestamp = new Date(class_datetime.substring(0, class_datetime.length - 3)).getTime()
        newTownHalls[i].commentsall = newTownHalls[i].commentsall || 0
      }
      if (field === "signup" || field === "class_price" || field === "class_datetime") {
        if (order === "ascending") {
          order = 'desc'
        } else {
          order = 'asc'
        }
      } else {
        if (order === "ascending") {
          order = 'asc'
        } else {
          order = 'desc'
        }
      }
      if (field === "class_datetime" || field === "") {
        field = "timestamp"
      }
      let townHallsSorted:any = _.orderBy(newTownHalls, [field], [order]);
      let size = state.size_page || 10;
      let page = state.townHallPage || 1;
      let start_row = (page - 1) * size
      let end_row = ((page - 1) * size) + size
      let townHallsPageShowing: Array<any> = [];
      if (inputSearchTownhall && inputSearchTownhall.length > 2) {
        let re = new RegExp(state.inputSearchTownhall, 'gi')
        let response:any = _.filter(townHallsSorted, (item): any => {
          if (item && item.title && item.title.match(re)) {
            return true
          } else if (item && item.title != undefined && item.title.match(re)) {
            return true
          }
        });
        townHallsPageShowing = response
      } else {
        townHallsPageShowing = townHallsSorted
      }
      return townHallsPageShowing.slice(start_row, end_row) || []
    },
    townhall_all: ({ townhall_all }) => {
      return townhall_all
    },
    townhall_graphmonth: ({townhall_graphmonth}) => {
      return townhall_graphmonth
    },
    townhall_graphmonth16: ({townhall_graphmonth16}) => {
        return townhall_graphmonth16
    },
    townhall_total: ({townhall_total}) => {
        return townhall_total
    },
    townhall_total16: ({townhall_total16}) => {
        return townhall_total16
    },
    inputSearchTownhall: ({ inputSearchTownhall }) => {
      return inputSearchTownhall
    },
    townHallResults: ({ townHallResults }) => {
      return townHallResults
    },
    townHallShowing: ({ townHallShowing }) => {
      return townHallShowing
    },
    loadingTownHallTable: ({ loadingTownHallTable }) => {
      return loadingTownHallTable
    },
    adviser :({ adviser }) => {
      return adviser
    },
    creator :({ creator }) => {
      return creator
    },
    huddleTagData:({ huddleTagData }) => {
      return huddleTagData
    },
    comment:({ comment }) => {
      comment = _.sortBy(comment, function(dateObj) {
        return new Date(dateObj.createdate);
      });
      return comment
    },
    commentId:({ commentId }) => {
      return commentId
    },
    userAll:({ userAll }) => {
      return userAll
    },
    member:({ member }) => {
      return member
    },
    organization1level:(state:any) => {
      return state.organization1level
    },
    membersPoll:({ membersPoll }) => {
      return membersPoll
    },
    scheduledTownhall: (state: any) => state.scheduledTownhall,
    draftTownhall: (state: any) => state.draftTownhall,
  }
}
